class Http {
    get(url, headers) {
        return fetch(url, {
            method: 'GET',
            headers: {
                ...headers
            }
        })
            .then((response) => response.json());
    }

    delete(url, headers) {
        return fetch(url, {
            method: 'DELETE',
            headers: {
                ...headers
            }
        })
            .then((response) => response.json());
    }

    post(url, body, headers) {
        return fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
            .then((response) => response.json());
    }
}

module.exports = { Http };
